export * from './modules';
export * from './pipes/shared-pipes.module';
export * from './modules';
export * from './guard';



// WEBPACK FOOTER //
// /codebuild/output/src2455195120/src/src/app/shared/index.ts